// Dải "Kịch bản chưa gắn sản phẩm" (05/10/2026) — hàm THUẦN (không DOM) để kiểm bằng unit test (tests/unit/kich-ban-chua-sp.test.ts).
// Người dùng thật: tạo "Bình luận nhóm Facebook đã tham gia" (mong muốn "comment lên nhóm facebook đã tham gia"), AI đặt mục tiêu TƯƠNG TÁC, không
// gắn sản phẩm dù thư viện có "Mepo9 — phần mềm dựng video" → bot bình luận tự nhiên không nhắc sản phẩm → "không thấy quảng bá sản phẩm".
// Dải V5 cũ chỉ hiện khi mong muốn nói quảng bá → ca này không ai báo trước. Nay: kịch bản có bước SOẠN nội dung đăng ra ngoài (máy chủ báo
// coBuocSoan) mà chưa gắn sản phẩm → LUÔN có dải: mức THÔNG TIN (người dùng có thể cố ý chỉ tương tác), mong muốn / mục tiêu có ý quảng bá →
// mức CẢNH BÁO (câu V5). Không có bước soạn (chỉ lướt/thích) → không có dải.

/** Mong muốn / mục tiêu có ý quảng bá (V5 + 05/10: tiếp thị, marketing, seeding, PR, chốt đơn, ưu đãi, giảm giá). */
export const CAN_SAN_PHAM = /quảng bá|quảng cáo|sản phẩm|\bshop\b|cửa hàng|bán hàng|khuyến mãi|thương hiệu|giới thiệu (app|ứng dụng|phần mềm|dịch vụ|sản phẩm)|tiếp thị|marketing|seeding|\bPR\b|chốt đơn|ưu đãi|giảm giá/i;

export type MucChuaSp = "canh-bao" | "thong-tin";
export interface KbChoChuaSp { yeuCau: string; coBuocSoan?: boolean; soDo: { hoSo?: unknown; mucTieu?: string } | null }

/** null = không hiện dải (chưa có sơ đồ / đã gắn sản phẩm / không có bước soạn / máy chủ cũ không báo coBuocSoan). */
export function mucChuaSp(kb: KbChoChuaSp): MucChuaSp | null {
  if (!kb.soDo || kb.soDo.hoSo || kb.coBuocSoan !== true) return null;
  return CAN_SAN_PHAM.test(kb.yeuCau ?? "") || CAN_SAN_PHAM.test(kb.soDo.mucTieu ?? "") ? "canh-bao" : "thong-tin";
}

/** Câu chính của dải theo mức: [phần in đậm, phần còn lại]. Mức cảnh báo giữ ĐÚNG câu V5. */
export const CAU_CHUA_SP: Record<MucChuaSp, [string, string]> = {
  "canh-bao": ["Chưa chọn sản phẩm", " — bình luận sẽ không nhắc tới sản phẩm của bạn."],
  "thong-tin": ["Kịch bản chưa gắn sản phẩm", " — bình luận/bài đăng sẽ KHÔNG nhắc tới sản phẩm nào."],
};

const SO_TEN_GOI_Y = 3;
/**
 * Gợi ý tên sản phẩm có trong thư viện: null (không tải được) / rỗng → null; 1–3 → liệt kê; nhiều hơn → 3 tên đầu + số còn lại.
 * `cuaMinh` = false khi Super xem kịch bản của Boss khác (thư viện của chủ kịch bản, không phải của người đang xem).
 */
export function goiYThuVien(ds: readonly { ten: string }[] | null, cuaMinh = true): string | null {
  const ten = (ds ?? []).map((s) => (s.ten ?? "").trim()).filter(Boolean);
  if (!ten.length) return null;
  const chu = cuaMinh ? "Thư viện của bạn" : "Thư viện của chủ kịch bản";
  if (ten.length <= SO_TEN_GOI_Y) return `${chu} có: ${ten.join(" · ")}`;
  return `${chu} có ${ten.length} sản phẩm: ${ten.slice(0, SO_TEN_GOI_Y).join(" · ")} và ${ten.length - SO_TEN_GOI_Y} sản phẩm khác`;
}

/** Dòng nhắc trong hộp xác nhận Chạy thật (một bot / nhiều bot) — không chặn. */
export const NHAC_CHAY_THAT_SP = "Chưa gắn sản phẩm — bình luận sẽ không quảng bá sản phẩm";

/** Gợi ý dưới ô Mong muốn lúc tạo (theo sau là nút-liên-kết "Sản phẩm" mở mục Sản phẩm). */
export const GOI_Y_TAO_SP = "Muốn bình luận quảng bá sản phẩm? Chọn sản phẩm ở mục";
/** Hiện gợi ý lúc tạo: thư viện có sản phẩm (đã tải được) và người dùng CHƯA chọn / chưa gõ sản phẩm. */
export function canGoiYTaoSp(soSpThuVien: number | null, daCoSp: boolean): boolean {
  return !daCoSp && (soSpThuVien ?? 0) > 0;
}
